import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/admin/api/adminApi.js';

/**
 * Fires a page-view event to the backend whenever the public-site route
 * changes. Mounted on the public site only (never inside /admin) so admin
 * activity does not inflate visitor counts.
 *
 * De-dupes rapid repeats of the same path (e.g. React StrictMode's double
 * effect in dev, or quick re-renders) so each view is counted once.
 */
export function usePageTracking() {
  const location = useLocation();
  const lastTracked = useRef({ path: null, at: 0 });

  useEffect(() => {
    const path = location.pathname + location.search;
    const now = Date.now();

    // Skip a duplicate hit on the same path within a short window.
    if (lastTracked.current.path === path && now - lastTracked.current.at < 2000) {
      return;
    }
    lastTracked.current = { path, at: now };

    trackPageView({
      path,
      referrer: document.referrer || '',
      title: document.title || '',
    });
  }, [location.pathname, location.search]);
}
